import React from 'react';

import styled from '@emotion/styled';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

type TooltipType = 'primary' | 'disabled' | 'secondary' | 'warning' | 'error' | 'none';

interface ITooltipProps extends TooltipProps {
  maxwidth?: string;
  type?: TooltipType;
  title: string;
  customStyle?: any;
}

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const StyledTooltip = styled(({ className, customStyle, ...props }: ITooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} sx={{ display: 'flex' }} />
))(({ customStyle, maxwidth }: ITooltipProps) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--du-color-primary-light)',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    ...customStyle,
    borderRadius: '5px',
    padding: '2px 10px 1px',
    maxWidth: maxwidth || '800px',
    fontFamily: 'Diodrum-Semibold',
  },
}));

const TooltipTypesStyles = {
  primary: { color: 'var(--du-color-primary)', backgroundColor: 'var(--du-color-primary-pale)' },
  disabled: { color: 'var(--du-color-grey)', backgroundColor: 'var(--du-color-grey-light)' },
  secondary: { color: 'var(--du-color-white)', backgroundColor: 'var(--du-color-primary)' },
  warning: { color: 'var(--du-color-orange)', backgroundColor: 'var(--du-color-orange-light)' },
  error: { color: 'var(--du-color-red)', backgroundColor: 'var(--du-color-red-light)' },
  none: { display: 'none' },
};

const DupontTooltip: React.FC<ITooltipProps> = ({ title, type = 'primary', ...rest }) =>
  title ? <StyledTooltip {...rest} customStyle={TooltipTypesStyles[type]} title={title} /> : rest.children;
export default DupontTooltip;
